import React, { useEffect, useState } from 'react';
import { getHttpFunctionUrl, postJsonWithAuth } from '../firebase';
import BarraFiltros, { BotaoConsultar } from './BarraFiltros';

function AbaUsuarios({
  removerPerfilAtivo,
  alterarPlanoLojista,
  alternarStatusUsuario,
  adicionarPerfilManual,
  somenteConsulta = false,
}) {
  const [usuariosLocais, setUsuariosLocais] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [termoBusca, setTermoBusca] = useState('');
  const [tipoBusca, setTipoBusca] = useState('email');
  const [cursorDocId, setCursorDocId] = useState('');
  const [temMais, setTemMais] = useState(true);

  const TAMANHO_PAGINA = 20;
  const montarUrlFuncaoHttp = getHttpFunctionUrl;

  useEffect(() => {
    carregarUsuarios(true);
  }, []);

  const carregarUsuarios = async (recomecar = false, termoOverride = null, tipoOverride = null) => {
    setCarregando(true);
    try {
      const termo = termoOverride !== null ? termoOverride : termoBusca;
      const tipo = tipoOverride !== null ? tipoOverride : tipoBusca;

      if (recomecar) {
        setCursorDocId('');
        setTemMais(true);
      }

      const resposta = await postJsonWithAuth(montarUrlFuncaoHttp('gerenciarUsuariosPainel'), {
        action: 'list_users',
        searchType: tipo,
        searchTerm: termo,
        cursorDocId: recomecar ? '' : cursorDocId,
        pageSize: TAMANHO_PAGINA,
      });
      const dadosRetorno = await resposta.json().catch(() => ({}));

      if (!resposta.ok || !dadosRetorno?.sucesso) {
        throw new Error(dadosRetorno?.erro || 'Não foi possível carregar a lista de usuários agora.');
      }

      const lista = Array.isArray(dadosRetorno?.users) ? dadosRetorno.users : [];

      if (recomecar) {
        setUsuariosLocais(lista);
      } else {
        setUsuariosLocais((prev) => [...prev, ...lista]);
      }

      setCursorDocId(dadosRetorno?.nextCursorDocId || '');
      setTemMais(Boolean(dadosRetorno?.nextCursorDocId));
    } catch (e) {
      console.error('Erro ao buscar usuários:', e);
      alert('Erro na busca. Revise o filtro informado e tente novamente.');
    } finally {
      setCarregando(false);
    }
  };

  const handleBusca = (e) => {
    e.preventDefault();
    carregarUsuarios(true);
  };

  const limparBusca = () => {
    setTermoBusca('');
    carregarUsuarios(true, '', tipoBusca);
  };

  const atualizarUsuarioNaTela = async (usuarioAtualizado) => {
    if (!usuarioAtualizado?.id) return;
    setUsuariosLocais((prev) => prev.map((user) => (user.id === usuarioAtualizado.id ? { ...user, ...usuarioAtualizado } : user)));
  };

  const aoRemoverPerfil = async (u, perf) => {
    const usuarioAtualizado = await removerPerfilAtivo(u, perf);
    await atualizarUsuarioNaTela(usuarioAtualizado);
  };

  const aoAlterarPlano = async (u, novoPlano) => {
    let gerarCobranca = false;
    let diasCarencia = 0;
    let isencaoProRata = false;

    const isUpgrade = Boolean(u.asaas_subscription_id) && (u.plano && u.plano !== 'gratuito');

    if (novoPlano !== 'gratuito') {
      if (isUpgrade) {
        const cobrarProRata = window.confirm(
          `O cliente já possui o plano ${u.plano.toUpperCase()} ativo.\n\nDeseja cobrar o pro-rata da diferença para o plano ${novoPlano.toUpperCase()}?\n\nOK = Sim, cobrar a diferença agora.\nCancelar = Não, tratar como isenção no ciclo atual.`,
        );
        gerarCobranca = true;
        isencaoProRata = !cobrarProRata;
      } else {
        const cobrancaImediata = window.confirm(
          `Deseja gerar a cobrança imediata no Asaas para o plano ${novoPlano.toUpperCase()}?\n\nOK = Sim, cobrar hoje.\nCancelar = Não, definir um período de carência.`,
        );

        if (cobrancaImediata) {
          gerarCobranca = true;
          diasCarencia = 0;
        } else {
          const dias = window.prompt(
            `Defina o período de carência para o plano ${novoPlano.toUpperCase()}.\n\nInforme quantos dias de degustação deseja liberar.`,
            '30',
          );

          if (dias === null) return;

          diasCarencia = parseInt(dias, 10);
          if (Number.isNaN(diasCarencia) || diasCarencia <= 0) {
            window.alert('Número de dias inválido. Alteração cancelada.');
            return;
          }
          gerarCobranca = true;
        }
      }
    } else if (!window.confirm(`Tem certeza que deseja rebaixar ${u.nome} para o plano gratuito?`)) {
      return;
    }

    const usuarioAtualizado = await alterarPlanoLojista(u, novoPlano, gerarCobranca, diasCarencia, isencaoProRata, isUpgrade);
    await atualizarUsuarioNaTela(usuarioAtualizado);
  };

  const aoAlternarStatus = async (u) => {
    const usuarioAtualizado = await alternarStatusUsuario(u);
    await atualizarUsuarioNaTela(usuarioAtualizado);
  };

  const aoAdicionarPerfil = async (u, novoPerfil) => {
    if (!novoPerfil) return;
    const usuarioAtualizado = await adicionarPerfilManual(u, novoPerfil);
    await atualizarUsuarioNaTela(usuarioAtualizado);
  };

  const placeholderBusca = {
    email: 'Ex: joao@gmail.com',
    nome: 'Ex: João Silva',
    perfil: 'Ex: lojista, admin, moderador, técnico',
    plano: 'Ex: gratuito, bronze, prata, ouro, diamante',
  };

  const classePerfil = (perfil) => {
    if (perfil === 'admin') return 'admin-chip admin-chip--admin';
    if (perfil === 'moderador') return 'admin-chip admin-chip--moderador';
    if (perfil === 'tecnico') return 'admin-chip admin-chip--tecnico';
    if (perfil === 'lojista') return 'admin-chip admin-chip--lojista';
    return 'admin-chip';
  };

  const rotuloPerfil = (perfil) => {
    if (perfil === 'usuario') return 'USUÁRIO';
    if (perfil === 'tecnico') return 'TÉCNICO';
    return String(perfil || '').trim().toUpperCase();
  };

  return (
    <div className="routine-panel">
        <BarraFiltros rotulo="Filtros de usuarios" onSubmit={handleBusca} acoes={<>
          <BotaoConsultar disabled={carregando} />
          {termoBusca && (
            <button type="button" onClick={limparBusca} disabled={carregando} className="routine-btn routine-btn--soft">Limpar</button>
          )}
        </>}>
          <div className="routine-field">
            <label className="routine-label" htmlFor="usuarios-filtro">Filtro</label>
            <select
              id="usuarios-filtro"
              value={tipoBusca}
              onChange={(e) => {
                setTipoBusca(e.target.value);
                setTermoBusca('');
              }}
              className="routine-select"
            >
              <option value="email">E-mail</option>
              <option value="nome">Nome</option>
              <option value="perfil">Perfil</option>
              <option value="plano">Plano</option>
            </select>
          </div>

          <div className="routine-field routine-field--grow">
            <label className="routine-label" htmlFor="usuarios-busca">Busca</label>
            <input
              id="usuarios-busca"
              type="text"
              placeholder={placeholderBusca[tipoBusca]}
              value={termoBusca}
              onChange={(e) => setTermoBusca(e.target.value)}
              className="routine-input"
            />
          </div>

        </BarraFiltros>

      {somenteConsulta && (
        <div className="routine-callout routine-callout--warm" style={{ marginBottom: '16px' }}>
          <p className="routine-callout__text">
            Perfil técnico em modo somente consulta. Alterações de usuários, perfis e planos ficam bloqueadas.
          </p>
        </div>
      )}

      <div className="routine-table-wrap">
        <table className="routine-table" style={{ minWidth: '860px' }}>
          <thead>
            <tr>
              <th>Usuário</th>
              <th>Perfis ativos</th>
              <th style={{ textAlign: 'center' }}>Plano</th>
              <th style={{ textAlign: 'center' }}>{somenteConsulta ? 'Consulta' : 'Ações'}</th>
            </tr>
          </thead>
          <tbody>
            {usuariosLocais.map((u) => (
              <tr key={u.id}>
                <td>
                  <div className="admin-user-card">
                    <strong className="admin-user-card__name">{u.nome || 'Sem nome cadastrado'}</strong>
                    <span className="admin-user-card__email">{u.email}</span>
                    <div className="admin-user-card__meta">
                      <span className={`routine-status ${u.is_ativo === false ? 'routine-status--warning' : 'routine-status--success'}`}>
                        {u.is_ativo === false ? 'Bloqueado' : 'Ativo'}
                      </span>
                    </div>
                  </div>
                </td>

                <td>
                  <div className="admin-chip-row">
                    {(u.perfis_ativos || []).map((perf) => (
                      <span key={perf} className={classePerfil(perf)}>
                        {rotuloPerfil(perf)}
                        {!somenteConsulta && perf !== 'usuario' && (
                          <button type="button" className="admin-chip__remove" onClick={() => aoRemoverPerfil(u, perf)}>
                            x
                          </button>
                        )}
                      </span>
                    ))}
                  </div>
                </td>

                <td style={{ textAlign: 'center' }}>
                  {(u.perfis_ativos || []).includes('lojista') ? (
                    somenteConsulta ? (
                      <strong>{String(u.plano || 'gratuito').toUpperCase()}</strong>
                    ) : (
                      <select
                        value={u.plano || 'gratuito'}
                        onChange={(e) => aoAlterarPlano(u, e.target.value)}
                        className={`admin-select-compact ${u.plano === 'diamante' ? 'is-diamond' : ''}`}
                      >
                        <option value="gratuito">Gratuito</option>
                        <option value="bronze">Bronze</option>
                        <option value="prata">Prata</option>
                        <option value="ouro">Ouro</option>
                        <option value="diamante">Diamante</option>
                      </select>
                    )
                  ) : (
                    '---'
                  )}
                </td>

                <td>
                  {somenteConsulta ? (
                    <span className="routine-section-subtitle" style={{ margin: 0 }}>
                      Consulta liberada
                    </span>
                  ) : (
                    <div className="admin-actions-row">
                      <button
                        type="button"
                        onClick={() => aoAlternarStatus(u)}
                        className={`routine-btn ${u.is_ativo === false ? 'routine-btn--primary' : 'routine-btn--danger'}`}
                      >
                        {u.is_ativo === false ? 'Ativar' : 'Bloquear'}
                      </button>

                      <select
                        className="admin-select-compact"
                        onChange={(e) => {
                          aoAdicionarPerfil(u, e.target.value);
                          e.target.value = '';
                        }}
                        defaultValue=""
                      >
                        <option value="">Adicionar perfil</option>
                        <option value="lojista">Lojista</option>
                        <option value="moderador">Moderador</option>
                        <option value="tecnico">Técnico</option>
                        <option value="admin">Admin</option>
                      </select>
                    </div>
                  )}
                </td>
              </tr>
            ))}

            {usuariosLocais.length === 0 && !carregando && (
              <tr>
                <td colSpan="4" className="routine-empty">
                  Nenhum usuário encontrado para esse filtro.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        {carregando && <p className="routine-section-subtitle" style={{ margin: 0 }}>Carregando dados...</p>}

        {!carregando && temMais && usuariosLocais.length > 0 && (
          <button type="button" onClick={() => carregarUsuarios(false)} className="routine-btn routine-btn--soft">
            Carregar mais usuários
          </button>
        )}

        {!carregando && !temMais && usuariosLocais.length > 0 && (
          <p className="routine-section-subtitle" style={{ margin: 0 }}>
            Fim da lista de usuários.
          </p>
        )}
      </div>
    </div>
  );
}

export default AbaUsuarios;
